import {getDonorsList} from '@/libs/api/api'
import {isEmpty} from 'lodash'
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue'
import {getImageUrl, onError} from '@/libs/helper'
import { mapGetters } from 'vuex'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'DonorsList',
    components: {
        SettingsDropdown
    },
    data() {
        return {
            getImageUrl,
            onError,
            currentPage: 1,
            skip: 0,
            limit: 30,
            sort: 'name',
            order: 'desc',
            donorList: [],
            columns: ['name', 'date', 'donation', 'type', 'settings'],
            tableSettings: {
                headings: {
                  name: 'Name',
                  donation: 'Donation',
                  settings: '',
                  type: 'Type',
                  date: 'Date'
                },
                pagination: { show: false},
                filterable: [],
                filterByColumn: true,
                sortable: ['no'],
            },
            loading:false,
            searchValue:'',
            selectedSearchValue:'',
            donorListTemp:[],
            searchedDonorList:[],
            permissions: permissions
        }
    },
    computed:{
        ...mapGetters(['hasPermission'])
    },
    props: {
        selectedValue: {
            type: Object,
            default: () => {}
        },
        accountStatus: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        accountStatus () {
            this.fetchDonorsList()
        }
    },
   async mounted () {
        await this.fetchDonorsList()
    },
    methods: {
        async fetchDonorsList () {
            if (!this.accountStatus.details_submitted) {
                return;
            }
            if(!this.hasPermission(permissions.donorslist)) return;
            this.loading=true
            if (!isEmpty(this.accountStatus)) {
                // body for api
                let body = {
                    destination: this.accountStatus.connected_account_id
                }
               await getDonorsList(body)
                .then(response => {
                    this.donorList = (response && response.list) || []
                    this.loading=false
                })
                .catch(error => {
                    console.error(error)
                    this.loading=false
                })
            }
        },
        getDate (date) {
            if (date !== undefined && date !== null) {
                // multiply by 1000 as its a unix date
                let d = new Date((date*1000))
                return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear()
            }
        },
        /**
         * route to member page
         */
         routeToMember (user) {
            if (!isEmpty(user)) this.$router.push({name: `users-overview`, params: {id: user._id}})
        },
        async querySearch(query , cb){
            this.donorListTemp=[...this.donorList]
            const result=await this.donorList.filter((item)=> item.user && item.user.last_name.toLowerCase().includes(query))
            this.searchedDonorList=[...result]
            cb(result)
        },
        changeOrder () {},
        changePage () {},
        handleCommand () {
            
        },
        handleSelectSearchedValue(){
            this.donorList=this.searchedDonorList;
        },
    }
}